module.exports = __webpack_public_path__ + "img/telegram.1e1e55c8.png";